import Vue from 'vue'
import Vuex from 'vuex'
import TokenStore from './tokenStore'
import PlaybackStore from './playbackStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    TokenStore,
    PlaybackStore
  }
})
